/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $TimeOffStatus = {
    type: 'Enum',
};